import { createFileRoute } from '@tanstack/react-router'
import { SchedulePanel } from '../components/services/ServicesPanels.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'
import { sectionCrumbs } from '../lib/services-crumbs.ts'

/** Who serves when, across the coming plans. */
export const Route = createFileRoute('/_authed/_shell/services/_sections/schedule')({
  component: ScheduleScreen,
})

function ScheduleScreen() {
  useBreadcrumbs(sectionCrumbs('Schedule'))
  return <SchedulePanel />
}
